import { Injectable } from '@angular/core';
import { DefaultService } from '@psnb/psnb-api';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AllPowerSuppliesService {

  constructor(private powerSupplyService: DefaultService) {
    this.getAllPowerSupplies();
  }

  getAllPowerSupplies() {
    return this.powerSupplyService.getPowerSupplyList().pipe(map(result => result));
  }

}

